import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getSSSService } from "../../../services/common.service";
import { alertActions } from "../../../state/ducks/alert/actions";
import EminevimLoading from "../shared/EminevimLoading";

class Questions extends Component {
  state = {
    sss: null,
    isLoading: true,
    shouldAnimateCard: false,
  };

  getSSS = () => {
    this.setState({ sss: null, isLoading: true });
    getSSSService()
      .then(
        (response) => {
          if (response.success) {
            this.setState({ sss: response.data });
          } else {
            this.props.showError(response.message);
            this.setState({ sss: [] });
          }
        },
        () => {
          this.setState({ sss: [] });
        }
      )
      .finally(() => {
        this.setState({ isLoading: false, shouldAnimateCard: true });
        window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
      });
  };

  componentDidMount() {
    this.getSSS();
  }

  renderQuestionsLoading = () => (
    <EminevimLoading subtext="Sıkça sorulan sorular hazırlanıyor, lütfen bekleyiniz." />
  );

  render() {
    const { sss, isLoading, shouldAnimateCard } = this.state;

    return (
      <div style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
        

            {isLoading ? (
              this.renderQuestionsLoading()
            ) : (
              <article
                className={`t-memberInfo-card t-memberDetail-header--green${shouldAnimateCard ? " t-memberInfo-card--enter" : ""
                  }`}
              >
                <div className="t-memberInfo-cardHeader">
                  <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                    <i className="t-icon-question1" aria-hidden="true" />
                  </div>

                  <div className="t-memberInfo-cardHeaderContent">
                    <h2 className="t-memberInfo-cardTitle">Sıkça Sorulan Sorular</h2>
                    <div className="t-memberInfo-cardBadges">
                      <p className="t-memberInfo-pageSubtitle">
                        Merak ettiğiniz konulara hızlıca yanıt bulun; ihtiyaç duyarsanız temsilcinize soru iletebilirsiniz.
                      </p>
                    </div>
                  </div>

                  <div className="t-memberInfo-cardActions">
                    <Link
                      to="/Home/AskToAgent"
                      className="t-memberInfo-btn t-memberInfo-btn--primary"
                    >
                      <span>Temsilcime Sor</span>
                      <i className="t-icon-arrow-right2" aria-hidden="true" />
                    </Link>
                  </div>
                </div>

                {sss && sss.length > 0 ? (
                  <div className="t-questions-list accordion" id="sss1">
                    {sss.map((item, index) => (
                      <div className="t-questions-item" key={item.id || index}>
                        <button
                          type="button"
                          className="t-questions-itemHeader"
                          data-toggle="collapse"
                          data-target={`#to${item.id}`}
                          aria-expanded="false"
                          aria-controls={`to${item.id}`}
                        >
                          <span
                            className="t-questions-category"
                            style={{ color: item.renk || "#1b5e20" }}
                          >
                            {item.tur}
                          </span>
                          <span className="t-questions-question">{item.soru}</span>
                          <i className="t-icon-keyboard_arrow_down t-questions-chevron" aria-hidden="true" />
                        </button>

                        <div
                          id={`to${item.id}`}
                          className="collapse t-questions-answerWrap"
                          data-parent="#sss1"
                        >
                          <div
                            className="t-questions-answer"
                            dangerouslySetInnerHTML={{ __html: item.cevap }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="t-questions-empty">Gösterilecek soru bulunamadı.</p>
                )}
              </article>
            )}
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  showError: (message) => dispatch(alertActions.error(message)),
});

export default connect(null, mapDispatchToProps)(Questions);
